import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import Particles from "../../components/animation/particles/particles";

const DigitalServicesHero = ({
    banner,
    title,
    description,
    imageLgSize="75%",
    bannerBottomSpacing=0
}) => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    
    return (
        <>
            <Stack
                direction='column'
                alignContent='center'
                justifyContent='center'
                sx={{
                    width: '100%',
                    pt: {xs: 3, md: 0},
                    position: 'relative'
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: {xs: "40vh", lg: "60vh"},
                        overflow: "hidden",
                        zIndex: 0
                    }}
                >
                    <Particles
                        particleColors={[theme.palette.primary.main, theme.palette.primary.contrastText]}
                        particleCount={isMobile ? 500 : 1000}
                        particleSpread={isMobile ? 25 : 15}
                        speed={0.1}
                        particleBaseSize={100}
                        moveParticlesOnHover={false}
                        alphaParticles={true}
                        disableRotation={false}
                    />
                </Box>

                <Stack
                    direction='row'
                    justifyContent='center'
                    sx={{
                        width: '100%',
                        zIndex: 1
                    }}
                >
                    <Box
                        sx={{
                            width: {xs: '90%', md: imageLgSize},
                            pb: bannerBottomSpacing
                        }}
                    >
                        <img 
                            src={banner}
                            alt="banner" 
                            style={{ 
                                width: "100%"
                            }}
                        />
                    </Box>
                </Stack>

                <Typography
                    color={theme.palette.text.primary}
                    fontWeight={900}
                    fontSize={{xs: 30, md: 45, lg: 60}}
                    sx={{
                        py: {xs: 1, md: 2},
                        zIndex: 1
                    }}
                    textAlign='center'
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 12, lg: 16}}
                    textAlign='center'
                    lineHeight={{xs: 1.5, md: 2}}
                    color={theme.palette.text.secondary}
                    pt={2}
                    sx={{
                        zIndex: 1
                    }}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}

export default DigitalServicesHero;